import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { isNative } from './utils/platform';

// Light-only theme: clear any leftover dark-mode preference from earlier builds.
try {
  document.body.classList.remove('theme-dark');
  localStorage.removeItem('adwary_dark_mode');
} catch { /* ignore */ }

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Purge any leftover service workers/caches that used to SPA-fallback /sitemap.xml.
if (!isNative && 'serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.getRegistrations().then((regs) => {
      regs.forEach((reg) => reg.unregister());
    });
    if (window.caches) {
      caches.keys().then((keys) => keys.forEach((key) => caches.delete(key)));
    }
    // One last update fetch so old workers replace themselves with the uninstall script.
    navigator.serviceWorker
      .register(`${process.env.PUBLIC_URL}/service-worker.js`, { updateViaCache: 'none' })
      .catch(() => {});
  });
}


